var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-show',{attrs:{"item":_vm.item}},[_c('va-field',{attrs:{"source":"name"}}),_c('va-field',{attrs:{"source":"description"}}),_c('va-field',{attrs:{"source":"characteristics"}}),_c('va-field',{attrs:{"source":"images"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }